
import Constants from "./Constants";
import BroadcastWidgetWindow from "../widgets/BroadcastWidgetWindow";
import AudioVideoClient from './AudioVideoClient'

export default class Broadcast{
    constructor(rTPaaSProctorObj){
        this.RTPaaSProctorObj = rTPaaSProctorObj;
        this.init();
    }

    init(){
        this.broadcastWidgetWindow = new BroadcastWidgetWindow();
    }

    createBroadcastWidget(){
        this.broadcastWidgetWindow.createBroadcastWidget(this.RTPaaSProctorObj, this.RTPaaSProctorObj.testerHandStatuses);
        this.broadcastWidgetWindow.createBroadcastKendoChat(this.sendMessageBroadcastChatHandler.bind(this));
        this.handleHistory().then(() => {
            this.attachListeners();
        });
    }

    attachListeners(){
        this.broadcastWidgetWindow.groupAudioCallBtn.off('click',this.handleGroupAudioCallClick.bind(this)).on('click',this.handleGroupAudioCallClick.bind(this));
        this.broadcastWidgetWindow.endBtn.off('click',this.handleEndGroupCallClick.bind(this)).on('click',this.handleEndGroupCallClick.bind(this));
        this.broadcastWidgetWindow.chatBtn.off('click',this.handleBroadcastChatClick.bind(this)).on('click',this.handleBroadcastChatClick.bind(this))
        $(document).off('attendeeJoinedGroupCall',this.handleAttendeePresent.bind(this)).on('attendeeJoinedGroupCall',this.handleAttendeePresent.bind(this));
        $(document).off('studentDroppedGroupCall',this.handleStudentDroppedGroupCall.bind(this)).on('studentDroppedGroupCall',this.handleStudentDroppedGroupCall.bind(this));
        $(document).off('lowerTesterHand',this.lowerTesterHand.bind(this)).on('lowerTesterHand',this.lowerTesterHand.bind(this));
        $(document).off('toggleTesterMute',this.toggleTesterMute.bind(this)).on('toggleTesterMute',this.toggleTesterMute.bind(this));
        $(document).off('toggleProctorMute',this.toggleProctorMute.bind(this)).on('toggleProctorMute',this.toggleProctorMute.bind(this));
    }

    sendMessageBroadcastChatHandler(e){
        if(e.sender._events.sendMessage.length == 1) {
            this.RTPaaSProctorObj.sendBroadcastMsgToAllStudents(e.text);
        }
    }

    handleHistory() {
        let that = this;
        //only retrieve history after opening a window for the first time
        return new Promise((resolve, reject) => {
            this.RTPaaSProctorObj.retrieveBroadcastHistory().then(
                (history) => {
                    that.replayHistory(that, history).then(() => {});
                    that.RTPaaSProctorObj.determineGroupCallStatus(history);
                },
                (err) => {
                    console.log(err);
                }
            ).finally(() => {
                resolve();
                this.broadcastWidgetWindow.windowDiv.removeClass('rtp-loading');
				this.broadcastWidgetWindow.windowDiv.find('.rtp-loading-icon').remove();
            });
        });
    }

    replayHistory(context, history) {
        return new Promise((resolve, reject) => {
            let maxHistorySize = 999;//Ably has a maximum of historical 1000 messages per channel.
            if (history.length > maxHistorySize) {
                console.log('History: Number of messages (' + history.length + ') exceeds the history limit (' + maxHistorySize + ').');
                return;
            }
            for (let message of history) {
                if(Constants.MessageNames.BROADCAST === message.data.messageName && Constants.EventTypes.BROADCAST_CHAT === message.data.eventType) {
                    context.RTPaaSProctorObj.handleBroadcastMessage(message);
                }
            }
            //only process the last 'BROADCAST_CALL' or 'BROADCAST_END_CALL' message, since that is the only one that is relavent.  It also prevents unnecessary notification messages.
            let callEvents = [Constants.EventTypes.BROADCAST_CALL, Constants.EventTypes.BROADCAST_END_CALL];
            for (let message of history.reverse()) {
                if(callEvents.includes(message.data.eventType)) {
                    context.RTPaaSProctorObj.handleBroadcastMessage(message);
                    break;
                }
            }
            resolve();
        });
    }

    postBroadcastMsg(message) {
        let textMessage = {'text' : message.data.text, 'timestamp' : message.data.jsonTimestamp};
        this.broadcastWidgetWindow.kendoChat.postMessage(textMessage);
    }

    handleBroadcastChatClick(){
        this.broadcastWidgetWindow.switchToBroadcastChat(this.RTPaaSProctorObj.getIsInGroupAudioCall());
    }

    handleGroupAudioCallClick(){
        //If another proctor is in a group call, this button shouldn't be clickable.  However, if this button is clickable somehow, such as when the user
        //manipulates the html in the browser, we should do nothing.
        if(this.RTPaaSProctorObj.getIsGroupAudioCallRunning() && !this.RTPaaSProctorObj.getIsInGroupAudioCall()) {
            return;
        }
        this.RTPaaSProctorObj.disableAllOtherStartButtons(this.RTPaaSProctorObj.activeCallTesterIdentifier);
        this.broadcastWidgetWindow.handleGroupAudioCallStart();
        if(!this.RTPaaSProctorObj.getIsGroupAudioCallRunning()){
            this.RTPaaSProctorObj.setIsInGroupAudioCall(true);
            this.initAudioVideoClient();
            this.RTPaaSProctorObj.startCallChime();
        }
    }

   async initAudioVideoClient(){
        let params = {
            clientId : `PROCTOR_${this.RTPaaSProctorObj.clientId}`,
            isGroupCall : true,
            isAttendeeProctor : true,
            remoteMuteAudioCallback : this.broadcastWidgetWindow.toggleTesterMuteButton.bind(this.broadcastWidgetWindow),
            endCallWithErrorCallback : this.endCallDueToError.bind(this)
        };
        this.audioVideoClient = new AudioVideoClient(params);
        this.audioVideoClient.startCall();
        this.groupCallingTimeout = setInterval(this.groupCallingTimeoutHandler.bind(this), 30000);
	}

    groupCallingTimeoutHandler(){
        if(this.audioVideoClient.attendees.size <= 1){
            this.handleNoAttendeePresent();
        }else{
            clearInterval(this.groupCallingTimeout);
            this.broadcastWidgetWindow.missedGroupCallStudentsUI(this.getStudentIdMap());
        }
    }

    handleAttendeePresent(e,data){
        this.broadcastWidgetWindow.attendeeJoined(data);
        this.RTPaaSProctorObj.stopCallChime();
    }

    handleNoAttendeePresent(){
        clearInterval(this.groupCallingTimeout);
        this.audioVideoClient.handleNoAttendeePresent();
        this.cleanupEndGroupAudioCall();
    }

    handleStudentDroppedGroupCall(e,student){
        this.broadcastWidgetWindow.handleStudentDroppedGroupCall(student);
        if(this.audioVideoClient.attendees.size <= 1){
            this.handleNoAttendeePresent();
        }
    }

    handleEndGroupCallClick(){
        this.endChimeGroupAudioCall();
        this.cleanupEndGroupAudioCall();
    }

    cancelGroupCall() {
        this.endChimeGroupAudioCall();
        this.broadcastWidgetWindow.handleEndGroupCall();
        this.RTPaaSProctorObj.stopCallChime();
        this.RTPaaSProctorObj.determineAllStartButtonStatuses();
        clearInterval(this.groupCallingTimeout);
        //need to inform everyone that the call has been cancelled.
        this.RTPaaSProctorObj.notifyEndGroupCallToAllStudents();
    }

    endCallDueToError() {
        this.broadcastWidgetWindow.postNotificationMsg(rtp_i18next.t("proctorWidget:proctorLeftGroupCall"));
		this.handleEndGroupCallClick();
	}

    lowerTesterHand(event, testerIdentifier) {
        this.RTPaaSProctorObj.lowerHand(testerIdentifier);
    }

    toggleTesterMute(event, testerIdentifier, shouldMute) {
        this.RTPaaSProctorObj.sendMuteMessage(testerIdentifier, shouldMute);
    }

    toggleProctorMute(event, shouldMute) {
        if(shouldMute) {
            this.audioVideoClient.muteLocalAudio();
        } else {
            this.audioVideoClient.unMuteLocalAudio();
        }
    }

    cleanupEndGroupAudioCall(reason){
        this.RTPaaSProctorObj.handleEndGroupCall(reason);
        this.broadcastWidgetWindow.handleEndGroupCall();
        clearInterval(this.groupCallingTimeout);
    }

    endChimeGroupAudioCall(){
        this.audioVideoClient.endMeeting();
    }

    raiseHand(testerIdentifier) {
        this.broadcastWidgetWindow.raiseHand(testerIdentifier);
    }

    lowerHand(testerIdentifier) {
        this.broadcastWidgetWindow.lowerHand(testerIdentifier);
    }

    getStudentIdMap(){
        return this.RTPaaSProctorObj.idAndNameMap;
    }

    endGroupAudioCallDueToNetworkIssue(){
        return new Promise((resolve, reject) => {
            try {
                this.broadcastWidgetWindow?.postNotificationMsg(rtp_i18next.t("proctorWidget:proctorLeftGroupCall"));
                this.broadcastWidgetWindow?.closeBroadcastWindow();
                this.broadcastWidgetWindow?.disableGroupCallBtn();
                this.audioVideoClient?.endMeeting();
                this.cleanupEndGroupAudioCall(Constants.EndGroupCallReason.NETWORK_ISSUE);
                this.cleanupController();
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    cleanupController(){
        this.broadcastWidgetWindow.cleanupController();
        clearInterval(this.groupCallingTimeout);
    }
}
